"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaError = exports.NOMFA = exports.SOFTWARE_TOKEN_MFA = exports.OTP_LENGTH = void 0;
// MFA constants
exports.OTP_LENGTH = 6;
exports.SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';
exports.NOMFA = 'NOMFA';
var MfaError;
(function (MfaError) {
    MfaError["NONE"] = "NONE";
    MfaError["INCORRECT_CODE"] = "INCORRECT_CODE";
})(MfaError = exports.MfaError || (exports.MfaError = {}));
